import PaymentIcon from '@mui/icons-material/Payment';
import MailIcon from '@mui/icons-material/Mail';
import ArticleIcon from '@mui/icons-material/Article';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import VerifiedIcon from '@mui/icons-material/Verified';
import YouTubeIcon from '@mui/icons-material/YouTube';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import * as theme from '../../../theme';

export default function ResourceItem({ children, ...props }) {
  const getIcon = () => {
    if (props.icon) {
      if (props.icon === 'money') {
        return <PaymentIcon sx={{ flex: '0 0 auto' }} />;
      } else if (props.icon === 'mail') {
        return <MailIcon sx={{ flex: '0 0 auto' }} />;
      } else if (props.icon === 'report') {
        return <ArticleIcon sx={{ flex: '0 0 auto' }} />;
      } else if (props.icon === 'cancelled') {
        return <EventBusyIcon sx={{ flex: '0 0 auto' }} />;
      } else if (props.icon === 'complete') {
        return <VerifiedIcon sx={{ flex: '0 0 auto' }} />;
      } else if (props.icon === 'video') {
        return <YouTubeIcon sx={{ flex: '0 0 auto' }} />;
      } else if (props.icon === 'calendar') {
        return <CalendarMonthIcon sx={{ flex: '0 0 auto' }} />;
      } else if (props.icon === 'call') {
        return <ContactPhoneIcon sx={{ flex: '0 0 auto' }} />;
      }
    }
  };

  return (
    <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
      <div className={'cardLink'} style={{ display: 'flex', flex: 3, width: '100%', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }} onClick={() => props.actionLink != null ? props.actionLink() : null}>
        <div style={{ ...theme.Container.flexRowFixed, padding: 8, alignItems: 'center' }}>
          {getIcon()}
          <div style={{ flex: 1, fontSize: 14, fontWeight: 500 }}>
            {props.label}
          </div>
          <div style={{ justifyContent: 'flex-end', alignItems: 'flex-end'}}>
            {props.secondary}
          </div>
        </div>
      </div>
    </div>
  );
}